export const PaginationEndMsg = ``;
export const EventLanguage = {
  EventForm: {
    dragNDropText:
      "Drag 'n' drop file here, or click to select files and only one image is allowed here",
    dragNDropTextMultiple: "Drag 'n' drop file here, or click to select files.",
    dragNDropRejectedText: "Some files will be rejected",
    dragNDropAcceptedText: "All files are Accepted",
    BasicInFoForm: {
      FormTitle: "Create Event",
      LocationText:
        "Help people in the area discover your event and let attendees know where to show up.",
      TimingText:
        "Tell event goers when your event starts and ends so they can make plans to attend.",
      AdvancedSettiing: "Advanced Settings",
      dateNTime: "Date and time",
      FormLabal: {
        evtTitle: {
          label: "Event Title",
          placeholder: "Be clear and descriptive.",
        },
        category: { label: "Category", placeHolder: "Category" },
        evtTag: {
          label: "Enter Tag",
          placeHolder: "Add keyword to your event.",
        },
        organizer: { label: "Organizer", placeHolder: "Organizer" },
        address: { label: "Address", placeHolder: "Address" },
        city: { label: "City", placeHolder: "City" },
        state: { label: "State", placeHolder: "State" },
        postalCode: { label: "Postal Code", placeHolder: "Postal Code" },
        country: { label: "Country", placeHolder: "Country" },
        singleDay: {
          labelHtml: `<div className="dot"></div>
        <span>Single Day</span>`,
          label: "",
        },
        multiDay: {
          labelHtml: `<div className="dot"></div>
        <span>Multi Day</span>`,
          label: "Multi Day",
        },
        eventStartDate: { label: "Event Start", placeHolder: "Event Start" },
        eventEndDate: { label: "Event End", placeHolder: "Event End" },
        startTime: { label: "Start Time", placeHolder: "Start Time" },
        endTime: { label: "End Time", placeHolder: "End Time" },
        displayStartTime: {
          label: "Display start time",
          placeHolder: "Display start time",
        },
        displayEndTime: {
          label: "Display end time",
          placeHolder: "Display end time",
        },
        timezone: { label: "Timezone" },
      },
    },
    DetailsForm: {
      VideoError: "Only danzflo video embed accepted",
      FormLabal: {
        eventImage: {
          label: "Event Thumbnail Image*",
          placeHolder:
            "This is the first image attendees will see at the top of your listing.",
        },
        description: { label: "Description", placeHolder: "Event Description" },
        eventGalleryImage: {
          label: "Event Gallery Images",
          placeHolder: "",
        },
        videoUpload: { label: "Video Upload", placeHolder: "Upload Link" },
      },
    },
  },
  UserEvents: {
    list: {
      Heading: "All Events",
      ButtonHeading: "Filter",
    },
    details: {
      Heading: "Event Details",
    },
    wishlist: {
      Heading: "Wishlist",
      ButtonHeading: "Filter",
    },
    filter: {
      Location: "Location",
      City: "City",
      Category: "Category",
      StartDate: "Start Date",
      EndDate: "End Date",
    },
    detail: {
      Gallery: "Gallery",
      Map: "Location Map",
      Organizer: "Organizer",
      Date: "Date",
      Time: "Time",
      Location: "Location",
      Name: "Name",
      Email: "Email",
      Tags: "Tags",
      Purchase: "Purchase Tickets",
      Promote: "Promote Event",
    },
    ticket: {
      Summary: "Order Summary",
      Subtotal: "Item Subtotal",
      Saving: "Your Saving",
      Total: "Total",
      Proceed: "Proceed to checkout",
      Promocode: "Promocode",
      Apply: "Apply",
      Qty: "Qty",
      Add: "Add to cart",
      Promocode_error: "Promocode not applicable",
    },
  },
  TicketTypeTableColumn: {
    sNo: "Sr. No.",
    Ticket: "Ticket",
    QTY: "QTY",
    Price: "Price",
    InStaock: "In Stock",
    Action: "Action",
  },
  CreateEvent: {
    heading: "Create Event",
  },
  DeleteEventModal: {
    heading: "Cancel Event",
    message: "Are you sure you want to cancel this event?",
    delete: "Cancel",
  },
};
export const FormValidationMessages = (
  FieldName,
  FiledLabel,
  ValidationType,
  value
) => {
  const messages = {
    required: `${FiledLabel} is required`,
    minLength: `${FiledLabel} should be greater than ${value}`,
    maxLength: `${FiledLabel} should be less than ${value}`,
  };
  return messages[ValidationType];
};

export const TicketFormLanguage = {
  AdvancedSettiing: "Advanced Settings",
  PopUpTitle: "Create Ticket",
  FormLabal: {
    ticketName: { label: "Name", placeHolder: "Ticket Type Name" },
    quantity: {
      label: "Qty of ticket",
      placeHolder: "Quantity",
    },
    price: { label: "Price", placeHolder: "Price" },
    salesStart: { label: "Sales Start", placeHolder: "" },
    salesEnd: { label: "Sales End", placeHolder: "" },
    ticketStart: { label: "Valid From", placeHolder: "" },
    ticketEnd: { label: "Valid Till", placeHolder: "" },
    description: { label: "Description", placeHolder: "" },
    ticketPerOrder: {
      label: "Tickets per order:",
      placeHolder: { minQty: "Minimum Quantity", maxQty: "Maximum Quantity" },
    },
    hotelLink: { label: "Add Hotel Link:", placeHolder: "danzflo.com" },
  },
};

export const PromocodeLanguage = {
  Heading: "Promocode",
  ButtonHeading: "Add Promo Code",
  ListPromocodeTable: {
    Columns: {
      promocode: "CODE",
      type: "TYPE",
      discount: "DISCOUNT",
      minPurchase: "MIN. PURCHASE",
      expiryDate: "EXPIRY DATE",
      action: "ACTION",
    },
    NoPromocode: "No Promocode Found",
  },
  AddPromocodeForm: {
    FormTitle: "Add Promocode",
    FormLabal: {
      promocode: { label: "Promocode", placeHolder: "Promocode" },
      type: { label: "Type", placeHolder: "Type" },
      discount: { label: "Discount", placeHolder: "Discount" },
      minPurchase: {
        label: "Minimum Purchase",
        placeHolder: "Minimum Purchase",
      },
      expiryDate: { label: "Expiry Date", placeHolder: "Expiry Date" },
    },
    SubmitText: "Save",
  },
  DeletePromocodeModel: {
    title: "Delete Promocode",
    message: "Are you sure to delete this promocode?",
    submitText: "Delete",
  },
  EditPromocodeForm: {
    FormTitle: "Edit Promocode",
    FormLabal: {
      ticketName: { label: "Name", placeHolder: "Ticket Type Name" },
      quantity: { label: "Quantity", placeHolder: "Quantity" },
      price: { label: "Price", placeHolder: "Price" },
      salesStart: { label: "Sales Start", placeHolder: "" },
      salesEnd: { label: "Sales End", placeHolder: "" },
      ticketStart: { label: "Ticket Start", placeHolder: "" },
      ticketEnd: { label: "Ticket End", placeHolder: "" },
      description: { label: "Description", placeHolder: "" },
      ticketPerOrder: {
        label: "Tickets per order:",
        placeHolder: { minQty: "Minimum Quantity", maxQty: "Maximum Quantity" },
      },
      hotelLink: { label: "Add Hotel Link:", placeHolder: "danzflo.com" },
    },
  },
};

export const CartLanguage = {
  attendees: {
    photo: "Photo",
    name: "Name",
    email: "Email",
    dob: "DOB",
    mobile: "Mobile",
    actions: "Actions",
    // promocode: { label: "Promocode", placeHolder: "Promocode" },
    type: { label: "Type", placeHolder: "Type" },
    discount: { label: "Discount", placeHolder: "Discount" },
    minPurchase: {
      label: "Minimum Purchase",
      placeHolder: "Minimum Purchase",
    },
    expiryDate: { label: "Expiry Date", placeHolder: "Expiry Date" },
  },
  SubmitText: "Save",
};

export const OrderLanguage = {
  OrderList: {
    heading: "My Orders",
  },
  ReceivedOrderList: {
    heading: "Received Orders",
  },
  DeleteOrder: {
    title: "Delete Order",
    message: "Are you sure to delete this order?",
    submitText: "Delete",
  },
  Columns: {
    eventname: "Event Name",
    registerdName: "Registered Name",
    email: "Email",
    contact: "Contact",
    tickets: "Tickets Type",
    price: "Price",
    actions: "Actions",
    dateOrder: "Date of Orders",
  },
  FilterForm: {
    FormTitle: "Orders: Since saled started",
    FormLabals: {
      event: { label: "Enter Event Name", placeHolder: "Event Name" },
      registered: {
        label: "Enter Registered Name",
        placeHolder: "Registered Name",
      },
      minPrice: {
        label: "Min. Price",
        placeHolder: "Minimum Price",
      },
      maxPrice: {
        label: "Max. Price",
        placeHolder: "Maximum Price",
      },
      startDate: {
        label: "Start Date",
      },
      endDate: {
        label: "End Date",
      },
    },
    SubmitText: "Search",
  },
  OrderDetails: {
    heading: "Order Details",
    UserInformationList: {
      heading: "User Information Details",
      tableCoulmns: {
        name: "Name",
        email: "Email",
        date: "DOB",
        ticketType: "Ticket Type",
        phone: "Phone",
        action: "Action",
        status: "Status",
        cancelRequest: "Cancel Request",
      },
    },
    billingSection: {
      heading: "Billing Information",
      detialsColumn: {
        email: "Email",
        phone: "Phone",
        date: "Date",
        dob: "DOB",
      },
      orderSummery: {
        heading: "Order Summary",
        tableCoulmns: {
          subTotal: "Item Subtotal",
          saving: "Your Saving",
          total: "Total",
        },
      },
    },
    cancelModel: {
      heading: "Cancel Ticket",
      body: "Are you sure to cancel this ticket?",
      termsAndCondition: "Terms and Conditions",
      conditions:
        "Once your cancel requst is refunded you will not abel to apply for more cancel requests. So try to apply for all cancel requests at once.",
      submitButtonText: "Submit",
    },
  },
  TicketDetails: {
    heading: "Ticket Details",
  },
  Attendees: {
    heading: "Attendee",
    list: {
      heading: "Orders: Since saled started",
      Columns: {
        eventName: "Event Name",
        attendeeName: "Attendee Name",
        email: "Email",
        ticketType: "Ticket Type",
        checkIn: "Check In",
        checkOut: "Check Out",
        action: "Actions",
        status: "Status",
        photo:"Profile",
        BandId:"Band Id"
      },
    },
    details: {
      heading: "Attendee Details",
    },
  },
  CancelRequests: {
    heading: "Cancel Requests",
    list: {
      Columns: {
        ticketId: "Ticket Id",
        name: "Registered Name",
        email: "Email",
        contact: "Contact",
        attendant: "Request attendees",
        price: "Price",
        status: "Status",
        requestStatus: "Request Status",
        action: "Actions",
        date: "Date",
      },
    },
    model: {
      heading: "Cancel Request",
      body: "Your request has been successfully submitted",
    },
  },
  CheckoutForm: {
    contactInfo: {
      heading: "Contact Information",
      form: {
        firstName: { label: "First Name", placeHolder: "First Name" },
        lastName: { label: "Last Name", placeHolder: "Last Name" },
        email: { label: "Email", placeHolder: "Email" },
        confirmEmail: { label: "Confirm Email", placeHolder: "Confirm Email" },
      },
    },
    paymentMethod: {
      heading: "Payment Method",
      addCard: "Add Card",
      card: "Credit / Debit Card",
      form: {
        cardNumber: { label: "Card Number", placeHolder: "Card Number" },
        cardName: { label: "Card Name", placeHolder: "Card Name" },
        expiryDate: { label: "Expiry Date", placeHolder: "Expiry Date" },
        cvv: { label: "CVV", placeHolder: "CVV" },
      },
    },
  },
  PaymentRedund: {
    heading: "Payment Refund",
    list: {
      Columns: {
        photo: "Photo",
        name: "Name",
        email: "Email",
        phone: "Phone",
        date: "Date",
        status: "Status",
        action: "Actions",
      },
    },
    totalAmount: "User Event Total Amount",
    checkBox: "Pay Partial amount",
    refundAmount: "Refund Amount",
    submitButtonText: "Pay Now",
    refundModel: {
      heading: "Refund Ticket",
      body: "Payment Refund Success",
    },
  },
};

export const GuardLanguage = {
  Login: {
    heading: "Guard Login",
    form: {
      email: { label: "Email", placeHolder: "Email" },
      password: { label: "Password", placeHolder: "********" },
    },
    submitText: "Login",
  },
  DeleteGuard: {
    title: "Delete Guard",
    message: "Are you sure to delete this guard?",
  },
  Assign: {
    heading: "Assign Guard",
    form: {
      Heading: "Add New Guard",
      event: {
        label: "Event",
        placeHolder: "Select Event",
      },
      username: {
        label: "Username",
        placeHolder: "Username",
      },
      email: {
        label: "Email",
        placeHolder: "Email",
      },
      phone: {
        label: "Phone",
        placeHolder: "Phone",
      },
      dob: {
        label: "Date of Birth",
        placeHolder: "Date of Birth",
      },
      gender: {
        label: "Gender",
        placeHolder: "Select Gender",
      },
      name: {
        label: "Name",
        placeHolder: "Name",
      },
      password: {
        label: "Password",
        placeHolder: "*******",
      },
      action: {
        label: "Action",
        placeHolder: "Select Action",
      },
    },
    submitText: "Assign",
  },
  Edit: {
    Heading: "Edit Guard",
    submitText: "Save",
  },
};

export const PromoterLanguage = {
  Earning: {
    heading: "My Promotions Earning",
  },
  Assign: {
    heading: "Assign Promoter",
    addButtonText: "Add Promoter",
    form: {
      Heading: "Add New Promoter",
      name: {
        label: "Name",
        placeHolder: "Name",
      },
      email: {
        label: "Email",
        placeHolder: "Email",
      },
      phone: {
        label: "Phone",
        placeHolder: "Phone",
      },
    },
  },
};
